import {
    Box, Heading, RadioGroup, Text,
    VStack
} from '@chakra-ui/react';
import { FormStep } from '../MultiStepForm';
import RadioField from '../RadioField';


export default function Demographic(props: { onSubmit: any; formError: any; hasSkipButton: boolean; skipbuttonText: string; }) {
    const { onSubmit, formError } = props;
    return (
        <FormStep
            stepName="demographics"
            onSubmit={onSubmit}
            formError={formError}
        >
            <Box h="36rem">
                <VStack alignItems="center">
                    <Heading fontWeight={800}>
                        We’re committed to building a diverse workforce
                    </Heading>
                    <Text w="588px" color="#9A99A1">
                        This voluntary demographic data will help us better serve our growing
                        student base and is completely optional.
                    </Text>
                    <Text fontWeight={800} fontSize="18px">
                        How would you describe yourself?
                    </Text>
                    <Box alignItems="center" alignSelf="center" w="350px">
                        <RadioGroup id="demographics-group">
                            <RadioField
                                align="center"
                                topMargin="8px"
                                name="demographics"
                                type="radiobutton"
                                width="100px"
                                value="Asian or Pacific Islander"
                                text="Asian or Pacific Islander"
                            />
                            <RadioField
                                align="center"
                                topMargin="8px"
                                name="demographics"
                                type="radiobutton"
                                width="100px"
                                value="Black or African American"
                                text="Black or African American"
                            />
                            <RadioField
                                align="center"
                                topMargin="8px"
                                name="demographics"
                                type="radiobutton"
                                width="100px"
                                value="Hispanic or Latino"
                                text="Hispanic or Latino"
                            />
                            <RadioField
                                align="center"
                                topMargin="8px"
                                name="demographics"
                                type="radiobutton"
                                width="100px"
                                value="Native American or Alaskan Native"
                                text="Native American or Alaskan Native"
                            />
                            <RadioField
                                align="center"
                                topMargin="8px"
                                name="demographics"
                                type="radiobutton"
                                width="100px"
                                value="White or Caucasian"
                                text="White or Caucasian"
                            />
                            <RadioField
                                align="center"
                                topMargin="8px"
                                name="demographics"
                                type="radiobutton"
                                width="100px"
                                value="Middle Eastern"
                                text="Middle Eastern"
                            />
                            <RadioField
                                align="center"
                                topMargin="8px"
                                name="demographics"
                                type="radiobutton"
                                width="100px"
                                value="Multicultural or Biracial"
                                text="Multicultural or Biracial"
                            />
                            <RadioField
                                align="center"
                                topMargin="8px"
                                name="demographics"
                                type="radiobutton"
                                width="100px"
                                value="A race or ethnicity not listed"
                                text="A race or ethnicity not listed"
                            />
                        </RadioGroup>
                    </Box>
                </VStack>
            </Box>
        </FormStep>
    );
}
